import {createTheme} from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
    const color = colors;

    const defaultThemeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        secondaryLight: color.secondaryLight,
        secondaryDark: color.secondaryDark,
        primaryLight: color.primaryLight,
        primaryMain: color.primaryMain,
        primaryDark: color.primaryDark,
        primary200: color.primary200,
        primary800: color.primary800,
        customization
    };

    const darkThemeOption = {
        colors: color,
        heading: color.darkPrimary200,
        paper: color.darkPaper,
        backgroundDefault: color.darkPaper,
        background: color.darkBackground,
        darkTextPrimary: color.darkTextPrimary,
        darkTextSecondary: color.darkTextSecondary,
        textDark: color.darkPrimary200,
        menuSelected: color.darkSecondaryDark,
        menuSelectedBack: color.darkSecondaryLight,
        divider: color.darkSecondary200,
        secondaryLight: color.darkSecondaryLight,
        secondaryDark: color.darkSecondaryDark,
        primaryLight: color.darkPrimaryLight,
        primaryMain: color.darkPrimaryMain,
        primaryDark: color.darkPrimaryDark,
        primary200: color.darkPrimary200,
        primary800: color.darkPrimary800,
        customization
    };

    let themeOption;
    switch (customization.theme) {
        case 'light':
            themeOption = defaultThemeOption;
            break;
        case 'dark':
            themeOption = darkThemeOption;
            break;
        default:
            themeOption = defaultThemeOption;
            break;
    }

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions);

    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;
